import './images/rocket_up.png';
import './images/studing_boy.png';
import './index.erb';
import './index.module.scss';
import './index.rb';

export default class ChallengeFeedback {
  constructor() {
    const $dismissButton = $('.js-onboarding-dismiss');
    const $container = $('.js-onboarding-container');

    if ($dismissButton.length) {
      $dismissButton.on('click', () => $container.hide());
    }
  }
}
